<div class="slideshow-container">
  <a class="prev" (click)="minus()"><fa-icon [icon]="faChevronLeft" class="fad fa-chevron-left textColor harvest-gold base fa-2x"></fa-icon></a>

  <!-- Full-width images with number and caption text -->
  <ng-container *ngFor="let item of media; let i = index">
    <div class="mySlides fade" [class.active]="display == i || display+1 == i || display+2 == i || display+3 == i">
      <a *ngIf="item.external" target="blank" href="https://{{item.link}}">
        <img src="{{item.media}}" class="img-fluid gold-border">
      </a>
      <a *ngIf="!item.external" href="{{item.link}}">
        <img src="{{item.media}}" class="img-fluid gold-border">
      </a>
    </div>
  </ng-container>

  <!-- Next and previous buttons -->
  <a class="next" (click)="plus()"><fa-icon [icon]="faChevronRight" class="fad fa-chevron-right textColor harvest-gold base fa-2x"></fa-icon></a>
</div>